export default "__VITE_ASSET__Blfh6F0H__"